<seo-head></seo-head>
<debug></debug>
<alert-list></alert-list>
<header></header>
<pwp-section></pwp-section>
<router-outlet></router-outlet>
<u-dotcom-footer></u-dotcom-footer>
<ng-container #bottomMenu></ng-container>
